import { cn } from '@/utils/format';
import { CalendarEventChipRenderProps } from '../types';
import { CalendarChip } from './CalendarChip';

export const ShiftChip = ({ eventInfo }: CalendarEventChipRenderProps) => {
  const isAlerted = eventInfo.event.extendedProps.isAlerted;

  return (
    <CalendarChip
      eventInfo={eventInfo}
      className={cn(
        'border-0 flex items-end text-foreground',
        isAlerted ? 'bg-orange-400 dark:bg-orange-700' : 'bg-blue-200 dark:bg-blue-700',
      )}
    >
      <>
        <span className="font-bold">{eventInfo.timeText}</span>
        <span>{eventInfo.event.title}</span>
      </>
    </CalendarChip>
  );
};
